import * as iconLibrary from '../library';
import { RewardType } from '@/enums/reward-type';
import type { Icon } from '@/types/icons';

export const rewardTypeIcons: Record<number, Icon> = {
    [RewardType.Achievement]: iconLibrary.mdiTrophy,
    [RewardType.AccountQuest]: iconLibrary.mdiExclamationThick,
    [RewardType.Armor]: iconLibrary.mdiTshirtCrew,
    [RewardType.Cosmetic]: iconLibrary.mdiWizardHat,
    [RewardType.Currency]: iconLibrary.gameTwoCoins,
    [RewardType.Decor]: iconLibrary.gameHouse,
    [RewardType.Illusion]: iconLibrary.mdiAutoFix,
    [RewardType.Item]: iconLibrary.mdiGiftOutline,
    [RewardType.Mount]: iconLibrary.mdiUnicorn,
    [RewardType.Pet]: iconLibrary.gameFrog,
    [RewardType.Quest]: iconLibrary.mdiExclamationThick,
    [RewardType.Toy]: iconLibrary.mdiDiceMultiple,
    [RewardType.Transmog]: iconLibrary.mdiWizardHat,
    [RewardType.Weapon]: iconLibrary.mdiAxeBattle,
    [RewardType.XpQuest]: iconLibrary.gameUpgrade,

    [RewardType.InstanceSpecial]: iconLibrary.faDungeon,
    [RewardType.SetSpecial]: iconLibrary.mdiMulticast,
};
